import { useDocumentState } from '../../../contexts/DocumentContext';
import { DocumentSourceEnum } from '../../../components/document-wizard/document-editor/constants/EditorConstats';
import { ApprovalRequestStatus } from '../../../components/document-wizard/document-wizard-header/components/headerActions/requestReview/RequestInternalApprovalModalConstants';

export interface UseSendDropdownLogicParams {
  isDocumentCreator: boolean;
  hasCurrentTeamPossession: boolean;
  canShare: boolean;
  canEdit: boolean;
  canRequestInternalApproval: boolean;
  isReviewing: boolean;
  isDocumentEditable: boolean;
  documentSource: DocumentSourceEnum;
  approvalRequest?: any;
  shouldShowInternalSendForSigning: boolean;
  isPreparingToSign: boolean;
  isExecuted: boolean;
}

export const useSendDropdownLogic = ({
  isDocumentCreator,
  hasCurrentTeamPossession,
  canShare,
  canEdit,
  canRequestInternalApproval,
  isReviewing,
  isDocumentEditable,
  documentSource,
  approvalRequest,
  shouldShowInternalSendForSigning,
  isPreparingToSign,
  isExecuted,
}: UseSendDropdownLogicParams) => {
  const { state } = useDocumentState();
  const isEditorLoadedState = state.isEditorLoaded;
  const isEditorLoaded = documentSource === DocumentSourceEnum.APP ? isEditorLoadedState : true;

  const isApprovalRequestApproved = approvalRequest?.status === ApprovalRequestStatus.APPROVED;

  // Hide send dropdown in preparing_to_sign and executed states
  const isInSigningOrExecutedState = isPreparingToSign || isExecuted;

  // Core business logic extracted from DocumentWizardHeaderContainer
  const shouldShowDocumentActionsForReceiver = !isDocumentCreator && hasCurrentTeamPossession && isReviewing;
  const shouldShowSendDocumentButton = hasCurrentTeamPossession && isDocumentCreator && canShare;

  const shouldShowSendButton =
    isEditorLoaded &&
    (shouldShowSendDocumentButton || (shouldShowDocumentActionsForReceiver && canShare)) &&
    (!isApprovalRequestApproved || (isApprovalRequestApproved && !isDocumentEditable)) &&
    !isInSigningOrExecutedState; // Don't show send button in signing/executed states

  const shouldShowRequestInternalApprovalButton =
    isEditorLoaded && canRequestInternalApproval && hasCurrentTeamPossession && !isInSigningOrExecutedState;

  const shouldShowSendForSigning = isEditorLoaded && shouldShowDocumentActionsForReceiver && canEdit;

  // Main condition for showing RequestReviewContainer
  const shouldShowRequestReviewContainer =
    shouldShowSendButton || shouldShowRequestInternalApprovalButton || shouldShowInternalSendForSigning;

  return {
    shouldShowRequestReviewContainer,
    shouldShowSendButton,
    shouldShowRequestInternalApprovalButton,
    shouldShowSendForSigning,
    shouldShowInternalSendForSigning,
    isEditorLoaded,
  };
};
